<template>
  <div class="home-content" @click="handleClick">
    <Head ref="head"></Head>
    <section-1></section-1>
    <section-2></section-2>
    <section-3></section-3>
    <section-4></section-4>
    <section-5></section-5>
    <section-6></section-6>
    <section-7></section-7>
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import { isES } from '@/locales';
import { mapState } from 'vuex'
import Head from '../../components/head'
import Bottom from '../../components/bottom'
import Section1 from './components/section1.vue'
import Section2 from './components/section2.vue'
import Section3 from './components/section3.vue'
import Section4 from './components/section4.vue'
import Section5 from './components/section5.vue'
import Section6 from './components/section6.vue'
import Section7 from './components/section7.vue'
export default {
  name: 'Home',
  components: {
    Head,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
    Section7,
    Bottom
  },
  data () {
    return {
      isES
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  mounted(){},
  methods: {
    handleClick(){
      this.$refs.head.hidLangeList();
    },
  }
}
</script>
<style scoped lang="less">
.home-content {
  width: 100%;
  min-height: 100%;
  background: #F7F7F7;
  font-family: "PingFang SC";
}
</style>
